import { StatusUpdateStatuses } from 'api/status-updates/types';
import { FieldOptionBase } from 'api/tasks';
import {
  FieldType,
  MultiSelectField,
  NumberField,
  SingleSelectField,
  SourceType,
} from 'components/organisms/tasks/fields';

export const ProjectFieldsName = {
  pastProjectStatus: 'pastProjectStatus',
  projectHours: 'projectHours',
  lastMilestoneCSAT: 'lastMilestoneCSAT',
  csatRating: 'csatRating',
  projectPhases: 'projectPhases',
  inferredProgress: 'inferredProgress',
  status: 'status',
  projectName: 'projectName',
  progressPercent: 'progressPercent',
  estimatedDueDate: 'estimatedDueDate',
  arr: 'arr',
  projectFee: 'projectFee',
  dueDate: 'dueDate',
  startDate: 'startDate',
  projectAge: 'projectAge',
  plannedDuration: 'plannedDuration',
  startDateActual: 'startDateActual',
  dueDateActual: 'dueDateActual',
};

export const PastProjectStatusField: SingleSelectField = {
  fieldId: -100001,
  fieldName: ProjectFieldsName.pastProjectStatus,
  fieldLabel: 'Last project update',
  type: FieldType.SingleSelect,
  metaData: {
    options: Object.values(StatusUpdateStatuses).map(
      (opt) => ({ ...opt, value: opt.label } as unknown as FieldOptionBase),
    ),
  },
  customField: false,
  userCreated: false,
  private: false,
  sourceType: SourceType.Project,
};

export const LastMilestoneRatingField: NumberField = {
  fieldId: -100002,
  fieldName: ProjectFieldsName.lastMilestoneCSAT,
  fieldLabel: 'Last milestone rating',
  type: FieldType.Number,
  customField: false,
  userCreated: false,
  private: false,
  sourceType: SourceType.Project,
};

export const CsatRatingField: NumberField = {
  fieldId: -100003,
  fieldName: ProjectFieldsName.csatRating,
  fieldLabel: 'Overall rating',
  type: FieldType.Number,
  customField: false,
  userCreated: false,
  private: false,
  sourceType: SourceType.Project,
};

export const ProjectHoursField: NumberField = {
  fieldId: -100004,
  fieldName: ProjectFieldsName.projectHours,
  fieldLabel: 'Project hours',
  type: FieldType.Number,
  customField: false,
  userCreated: false,
  private: false,
  sourceType: SourceType.Project,
};

export const ProjectPhasesField: MultiSelectField = {
  fieldId: -100005,
  fieldName: ProjectFieldsName.projectPhases,
  fieldLabel: 'Project phases',
  type: FieldType.MultiSelect,
  metaData: {
    options: [],
  },
  customField: false,
  userCreated: false,
  private: false,
  sourceType: SourceType.Project,
};
